<template>
    <div class="columns is-mobile is-centered has-background-primary p-2"  v-if="props.vista=='completa'">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; FASE</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" v-if="props.vista=='completa'" @click="bAnnulla" :disabled="!faseDaAggiornare">Annulla</button>
                    <button class="button is-light" v-if="props.vista=='ridotta'" @click="bChiudi">Chiudi</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!faseDaAggiornare">Salva</button>

                </div>
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.vista=='completa'">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'lavoro', idCliente: props.idCliente, idLavoro: props.idLavoro})" title="Vai al lavoro">
                        <i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ leggiInfoDB(dbClienti[props.idCliente]?.lavori?.[props.idLavoro])?.stringaLavoroCorta }}
                    </a>
                </p>
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idFaseSelezionata!=-1">Elimina</button>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column is-2">
                <CampoTendina @valoreCambiato="(valore)=>faseModifica(valore, 'stato')"
                    :valore=faseSelezionata.stato
                    idTendina="fase.stato"
                    etichetta="Stato"/>
            </div>
            <div class="column is-2">
                <CampoTendina @valoreCambiato="(valore)=>faseModifica(valore, 'categoria')"
                    :valore=faseSelezionata.categoria
                    idTendina="fase.categoria"
                    etichetta="Categoria"/>
            </div>
            <div class="column is-3">
                <CampoTendina @valoreCambiato="(valore)=>faseModifica(valore, 'oggetto')"
                    :valore=faseSelezionata.oggetto
                    :idTendina="idTendina"
                    etichetta="Oggetto"/>
            </div>
            <div class="column is-2">
                <CampoTendina @valoreCambiato="(valore)=>faseModifica(valore, 'responsabile')"
                    :valore=faseSelezionata.responsabile
                    idTendina="fase.responsabile"
                    etichetta="Responsabile"/>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">Responsabile esterno</label>
                    <div class="control">
                        <input class="input" type="text" v-model="faseSelezionata.responsabileEsterno"  @change="faseModifica(faseSelezionata.responsabileEsterno, 'responsabileEsterno')">
                    </div>
                </div>
            </div>
            <div class="column is-1">
                <CampoNumero @valoreCambiato="faseModifica"
                    :valore=faseSelezionata.ordine
                    identificativo="ordine"
                    etichetta="Ordine"
                    tipo="Intero"/>
            </div>
        </div>
        <div class="columns">
            <div class="column is-2">
                <div class="columns">
                    <div class="column">
                        <CampoNumero @valoreCambiato="faseModifica"
                            :valore=faseSelezionata.lavoroStima
                            identificativo="lavoroStima"
                            etichetta="Giorni/squadra stimati"
                            tipo="Intero"/>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <CampoNumero @valoreCambiato="faseModifica"
                            :valore=faseSelezionata.lavoroEseguito
                            identificativo="lavoroEseguito"
                            etichetta="Giorni/squadra impiegati"
                            tipo="Intero"/>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label class="label">Note</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Note"  rows="5" v-model="faseSelezionata.note"  @change="faseModifica(faseSelezionata.note, 'note')"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

</template>

<script setup>
    import CampoNumero from "./CampoNumero.vue";
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    // FIX: Aggiunto watch
    import { defineProps, defineEmits, ref, computed, nextTick, watch } from "vue";
    import { dbClienti, salvaFaseInFirestore, eliminaFaseInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    // FIX: Aggiunto generaStringaCliente
    import { generaIdFase, clonaOggetto, generaStringaCliente } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idFase: {
            type: Number,
            default: -1
        },
        idLavoro: {
            type: Number,
            required: true
        },
        idCliente: {
            type: Number,
            required: true
        },
        vista: {                    // completa, ridotta
            type: String,
            default: 'completa'
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    // FIX: Inizializzazione sicura a {}
    const faseSelezionata = ref({});              
    const faseDaAggiornare = ref(null);             
    const messaggioModale = ref(null);              
    const idFaseSelezionata = ref(props.idFase || -1);
    const formAttivo = ref(true);                   

    // FIX: Watcher di sicurezza per cambi asincroni
    watch(() => props.idFase, (nuovoId) => {
        idFaseSelezionata.value = nuovoId || -1;
        setupFormFase();
    });

    const idTendina = computed( ()=>{
        let tempIdTendina = '';
        switch (faseSelezionata.value.categoria) {
            case 'Lavoro':
                tempIdTendina = 'fase.oggetto.lavoro';
                break;
            case 'Documentazione':
                tempIdTendina = 'fase.oggetto.documentazione';
        }
        return tempIdTendina;
    });

    // SETUP DEL COMPONENTE
    setupFormFase();

    // FUNZIONI DEL COMPONENTE
    function setupFormFase() {
        const id = idFaseSelezionata.value;

        // FIX: Scheletro di Base 
        const scheletroBase = {
            stato: null,
            categoria: null,
            oggetto: null,
            responsabile: null,
            responsabileEsterno: null,
            ordine: null,
            lavoroStima: null,
            lavoroEseguito: null,
            note: null
        };

        if ( id == -1 ) {
            faseSelezionata.value = { ...scheletroBase };
            aggiungiInfoDB(faseSelezionata.value, {
                id: -1,
                idCliente: props.idCliente,
                idLavoro: props.idLavoro,
                stringaCliente: generaStringaCliente(props.idCliente)
            });
        } else {
            // FIX: Estrazione Sicura
            const clienteOriginale = dbClienti.value[props.idCliente];
            const lavoroOriginale = (clienteOriginale && clienteOriginale.lavori) ? clienteOriginale.lavori[props.idLavoro] : null;
            const faseOriginale = (lavoroOriginale && lavoroOriginale.fasi) ? lavoroOriginale.fasi[id] : null;

            if (faseOriginale) {
                faseSelezionata.value = { ...scheletroBase, ...clonaOggetto(faseOriginale) };
                
                // FIX: Ricostruisce i metadati
                const infoRaw = leggiInfoDBRaw(faseOriginale) || { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro };
                aggiungiInfoDB(faseSelezionata.value, infoRaw);
            } else {
                faseSelezionata.value = { ...scheletroBase };
                aggiungiInfoDB(faseSelezionata.value, { id: id, idCliente: props.idCliente, idLavoro: props.idLavoro });
            }
        }
        faseDaAggiornare.value = null;
    }

    function faseModifica(valore, etichetta) {
        if (faseDaAggiornare.value == null) {
            faseDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        faseDaAggiornare.value[etichetta] = valore;
        faseSelezionata.value[etichetta] = valore;
    }

    function bChiudi() {
        if (faseDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Chiudi senza salvare le modifiche', comando:'chiudi'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        } else {
            emit('elementoSelezionato', {
                tipo: 'fase',
                idCliente: null,
                idLavoro: null,
                idFase: null
            });
        }
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche alla fase?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare la fase?"
        };
    }

    function bAnnulla() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
            messaggio:"Proseguendo perderai le modifiche fatte"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Sicurezza extra per evitare undefined se l'oggetto è orfano
        const tpIdCliente = leggiInfoDBRaw(faseSelezionata.value)?.idCliente || props.idCliente;
        const tpIdLavoro = leggiInfoDBRaw(faseSelezionata.value)?.idLavoro || props.idLavoro;

        // FIX: Raggruppati in scope isolati ({ }) per ESLint
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupFormFase();
                resetForm();
                break;
            }
            case 'chiudi': {
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                        tipo: 'fase',
                        idCliente: null,
                        idLavoro: null,
                        idFase: null
                    });
                messaggioModale.value = null;
                break;
            }
            case 'salva': {
                if (idFaseSelezionata.value == -1) {
                    idFaseSelezionata.value = generaIdFase(tpIdCliente, tpIdLavoro);
                }
                aggiungiInfoDB(faseDaAggiornare.value, {
                    id: idFaseSelezionata.value,
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro
                });
                await salvaFaseInFirestore(faseDaAggiornare.value);
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'fase',
                    idCliente: tpIdCliente,
                    idLavoro: tpIdLavoro,
                    idFase: idFaseSelezionata.value
                });
                break;
            }
            case 'elimina': {
                eliminaFaseInFirestore(tpIdCliente, tpIdLavoro, idFaseSelezionata.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'fasi'
                });
                break;
            }
        }
    }

    function gestisciSelezioneElemento(elSelezionato) {
        if (faseDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di uscire devi salvare o annullare le modifiche."
            };
        } else {
            emit('elementoSelezionato', elSelezionato);
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }
</script>